import {
  useCompanyPageStore,
  InstallFilters,
} from "../../../../../../../store/companyPageStore";

/**
 * Hook that provides install filters with automatic localStorage synchronization
 * This ensures filters persist across page refreshes and browser sessions
 */
export const useInstallFiltersStorage = () => {
  const { installFilters, setInstallFilters, resetInstallFilters } =
    useCompanyPageStore();

  // Helper function to update a specific filter
  const updateFilter = <K extends keyof InstallFilters>(
    key: K,
    value: InstallFilters[K]
  ) => {
    setInstallFilters({
      ...installFilters,
      [key]: value,
    });
  };

  // Helper function to clear a specific filter
  const clearFilter = (key: keyof InstallFilters) => {
    if (key === "includeCorporateDescendants") {
      updateFilter(key, false);
    } else {
      updateFilter(key, []);
    }
  };

  return {
    installFilters,
    setInstallFilters,
    resetInstallFilters,
    updateFilter,
    clearFilter,
  };
};
